import store from "../redux/store";
import actions from "../redux/actions";
import { BASE_URL } from "./config";
import { getHeader } from "./auth";
import { pricingVehicleType } from "../helper/vehicleTypeLabel";

export const isBrowser = () => typeof window !== "undefined";

export {
  handleLogin,
  updateUserProfile,
  updateAccountInfo,
  updateUserPassword,
  isLoggedIn,
  logout,
  handleRegister,
  forgotPassword,
  resetPassword,
  getHeader,
} from "./auth";

const getToken = () => {
  return store.getState()?.user?.token;
};
export const getPrices = async (unauthorizedCallback) => {
  const resp = await fetch(
    `${BASE_URL}/thg/prices/${process.env.GATSBY_COMPANY}/`,
    {
      headers: getHeader(),
    },
  );

  const response = await resp.json();
  if (response.error_code === 401) {
    store.dispatch(actions.user.resetUser());
    if (unauthorizedCallback) {
      unauthorizedCallback();
    }
    return null;
  } else {
    store.dispatch(actions.prices.setPrices(response?.data || []));
    return true;
  }
};
export const getQuotes = async (unauthorizedCallback) => {
  const resp = await fetch(`${BASE_URL}/thg/quote-years`, {
    headers: getHeader(true),
  });

  const response = await resp.json();
  if (response.error_code === 401) {
    store.dispatch(actions.user.resetUser());
    if (unauthorizedCallback) {
      unauthorizedCallback();
    }
    return null;
  } else {
    store.dispatch(actions.quotes.setQuotes(response?.data || []));
    return true;
  }
};

const appendIfPresent = (fd, key, value) => {
  if (value === undefined || value === null) return;

  // If it's a Date object, convert to YYYY-MM-DD
  if (value instanceof Date && !isNaN(value.getTime())) {
    const pad = (n) => String(n).padStart(2, "0");
    const ymd = `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(
      value.getDate(),
    )}`;
    fd.append(key, ymd);
    return;
  }

  const v = String(value).trim();
  if (!v || v === "undefined" || v === "null" || v === "EMPTY") return;

  fd.append(key, v);
};

export const addQuote = async (
  {
    number_plate,
    frontUpload,
    vehicle_type,
    vehicle_model,
    vehicle_brand,
    initial_registration,
    year,
    price_type,
    product_price_id,
    voucher,
  },
  unauthorizedCallback,
) => {
  const data = new FormData();

  data.append("frontUpload", frontUpload);
  data.append("site_ref", "public");

  appendIfPresent(data, "number_plate", number_plate);
  appendIfPresent(data, "vehicle_type", vehicle_type);
  appendIfPresent(data, "vehicle_model", vehicle_model);
  appendIfPresent(data, "vehicle_brand", vehicle_brand);
  appendIfPresent(data, "initial_registration", initial_registration);

  appendIfPresent(data, "year", year);
  appendIfPresent(data, "price_type", price_type);
  appendIfPresent(data, "product_price_id", product_price_id);
  appendIfPresent(data, "voucher", voucher);

  let resp;

  // 🌐 NETWORK ERROR (no backend reached)
  try {
    resp = await fetch(`${BASE_URL}/thg/quotes`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      body: data,
    });
  } catch (err) {
    const error = new Error(
      "Server konnte nicht erreicht werden. Bitte versuchen Sie es erneut.",
    );
    error.status = "NETWORK_ERROR";
    throw error;
  }

  const text = await resp.text();

  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    parsed = { message: text };
  }

  // 🔐 UNAUTHORIZED
  if (resp.status === 401) {
    store.dispatch(actions.user.resetUser());
    if (unauthorizedCallback) unauthorizedCallback();

    const error = new Error("Unauthorized");
    error.status = 401;
    error.data = parsed;
    throw error;
  }
  if (!resp.ok) {
    const error = new Error("Request failed");
    error.status = resp.status;
    error.data = parsed; // 🔥 backend message lives here
    throw error;
  }

  return parsed;
};

export const getPriceID = (prices, vType) => {
  var pId = 0;
  const normalizedType = pricingVehicleType(vTypeLowerCase(vType));
  prices.map((price) => {
    var type = price.p_desc.split("_");
    if (type.length > 1 && type[1] === normalizedType) pId = price.id;
  });
  return pId;
};

export const vTypeLowerCase = (vType) => {
  switch (vType) {
    case "M1":
      return "m1";
    case "M2":
      return "m2";
    case "N1":
      return "n1";
    case "M3":
      return "m3";
    default:
      return "other";
  }
};

export const splitBrandYear = (p_desc) => {
  var brandAndYear = p_desc.split("-");
  return brandAndYear;
};
